import { FormattedMessage, useIntl } from 'react-intl';

import { useDateUtils } from 'hooks';
import { ClinicalAssessment } from 'services';
import { getTranslatedResult } from 'services/user/resultTranslationHelper';

import { Table, TableColumn } from 'components';

import { ClinicalAssessmentTableProps } from './types';

import * as S from './styles';

export const ClinicalAssessmentTable: React.FC<ClinicalAssessmentTableProps> =
  ({ data, onClickAnswers }) => {
    const intl = useIntl();
    const { toLongDate } = useDateUtils();

    const AssessmentsColumns: TableColumn[] = [
      {
        dataKey: 'updated_at',
        key: 'data',
        title: intl.formatMessage({ id: 'ENDUSER.CLINICALASSESSMENT.DATE' }),
        render: (date: string) => toLongDate(new Date(date)),
      },
      {
        dataKey: 'value',
        key: 'points',
        title: intl.formatMessage({ id: 'ENDUSER.CLINICALASSESSMENT.POINTS' }),
      },
      {
        dataKey: 'result',
        key: 'results',
        title: intl.formatMessage({ id: 'ENDUSER.CLINICALASSESSMENT.RESULTS' }),
        render: result => getTranslatedResult(result, intl),
      },
      {
        dataKey: 'submission_id',
        key: 'responses',
        title: intl.formatMessage({ id: 'ENDUSER.CLINICALASSESSMENT.ANSWERS' }),
        render: (submissionId: string, row: ClinicalAssessment) => (
          <S.SeeResult
            onClick={() => onClickAnswers?.(submissionId, row.updated_at)}
          >
            <FormattedMessage id="ENDUSER.CLINICALASSESSMENT.SEEANSWERS" />
          </S.SeeResult>
        ),
      },
    ];
    return <Table columns={AssessmentsColumns} data={data} />;
  };
